import { Box, Button, Container, Stack, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../utils/sessionLogin";

export const SesionExpiraPage: React.FC<{}> = () => {
    
    const handleLogin =async ()=>{
        window.location.href = "/";;
    }


    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center' }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
                <Stack spacing={3} alignItems="center">
                    <Typography variant="h6" textAlign="center" color="textSecondary">
                    La sesión ha expirado. Por favor, inicie sesión nuevamente.
                    </Typography>
                    <Button
                    color="primary"
                    variant="contained"
                    sx={{
                        backgroundColor: "#243165",
                        color: "#FFFFFF !important",
                        "&:hover": { backgroundColor: "#1e284c" },
                        minWidth: "180px",
                        boxShadow: 3,
                    }}
                    onClick={() => { handleLogin(); }}
                    >
                    Ir al inicio de sesión...
                    </Button>
                </Stack>
            </Box>
        </Container>
    )
}